import { checkDefined } from 'faro-common-model';
export function toUserInfo(userInfo) {
    checkDefined(userInfo.id, 'UserInfo', 'id');
    checkDefined(userInfo.email, 'UserInfo', 'email');
    return {
        id: userInfo.id,
        idpId: userInfo.idpId,
        firstName: userInfo.firstName,
        lastName: userInfo.lastName,
        email: userInfo.email.toLowerCase(),
        roles: userInfo.roles ?? [],
    };
}
//# sourceMappingURL=user-info.js.map